import React, { useState, useEffect } from "react";
import { SubMarcas } from "./SubMarcas";
import { Cargando } from "../Cargando/Cargando";
import { getImageUrl } from "../../../utils/imageUtils";

// Mapeo de IDs internos de categorías
const categoriaIdMap = {
  "Capilar": "01",
  "Perfumería": "02",
  "Higiene y Cuidado de la piel": "05",
  "Maquillaje": "06",
  "Cuidado Facial": "04",
  "Bienestar": "07"
};

// Mapeo de IDs internos de marcas por nombre
const marcaIdMap = {
  "Dicora": "199",
  "Deven": "193",
  "Kanechom": "178",
  "Lattafa": "160",
  "Instituto Español": "117",
  "My Styles": "156",
  "Gigot": "174"
};

// Descripciones e imágenes por defecto para categorías
const categoriasInfo = {
  "01": {
    description: "¡Descubre el secreto de un cabello radiante y saludable con nuestra exclusiva línea de cuidado capilar! Desde los básicos esenciales como shampoo y acondicionador hasta tratamientos especializados, cremas de peinar, tintes innovadores, baños de color revitalizantes y gelatinas para estilos creativos, nuestra colección ofrece todo lo que necesitas para lograr el cabello de tus sueños. Con fórmulas enriquecidas con ingredientes de alta calidad, nuestros productos nutren, fortalecen y embellecen tu cabello, ofreciéndote la confianza y el estilo que te mereces. ¡Prepárate para deslumbrar con un cabello que refleje tu verdadera esencia y estilo único!",
    imagenPrincipal: "https://res.cloudinary.com/dkqp3wkbi/image/upload/v1679561440/capilar_iqkfx3.png"
  },
  "02": {
    description: "Déjate cautivar por la elegancia de nuestra exclusiva línea de perfumería importada directamente desde Emiratos Árabes. Cada fragancia es una obra maestra que encapsula la esencia del lujo y la sofisticación del Medio Oriente, creando una experiencia sensorial única que perdura en el tiempo. Descubre el arte de la perfumería de clase mundial con nuestra colección de perfumes de Dubai, donde el lujo y la elegancia se encuentran en cada gota.",
    imagenPrincipal: "https://res.cloudinary.com/dkqp3wkbi/image/upload/v1679561440/Perfumeria_yc9qkz.png"
  },
  "05": {
    description: "Descubre la esencia del cuidado corporal con nuestra exclusiva línea importada de España. Cada producto ofrece una experiencia única, elaborada con ingredientes naturales y fórmulas diseñadas para revitalizar la piel y el cuerpo. Disfruta de una piel radiante y un cuidado incomparable realzando tu belleza natural. ¡Bienvenidos a nuestra colección de cuidado e higiene corporal, donde encontrarás el mejor producto para cada tipo de piel!",
    imagenPrincipal: "https://res.cloudinary.com/dkqp3wkbi/image/upload/v1679561440/shutterstock_1543598711_kcgn3z.jpg"
  },
  "06": {
    description: "Descubre el poder transformador del maquillaje con nuestra línea completa de productos. Desde bases que perfeccionan la piel hasta polvos compactos que sellan el mejor acabado, labiales vibrantes que destacan tu sonrisa, delineadores precisos que realzan tu mirada, productos para cejas que enmarcan tu rostro y máscaras de pestañas que añaden volumen y longitud, nuestra colección ofrece todo lo que necesitas para crear looks espectaculares para cada ocasión.",
    imagenPrincipal: "https://res.cloudinary.com/dkqp3wkbi/image/upload/v1679561440/maquillaje_qkwpt4.png"
  },
  "04": {
    description: "Descubre nuestra línea premium de cuidado facial, diseñada para realzar y mantener la belleza natural de tu piel. Desde limpiadores suaves hasta tratamientos intensivos, cada producto está formulado con ingredientes de alta calidad para abordar diferentes necesidades cutáneas. Nuestra colección incluye serums concentrados, cremas hidratantes, mascarillas rejuvenecedoras y tratamientos específicos que trabajan en sinergia para revelar una piel radiante y saludable.",
    imagenPrincipal: "https://res.cloudinary.com/dkqp3wkbi/image/upload/v1679561440/cuidadoFacial_qvz5rw.jpg"
  },
  "07": {
    description: "Nuestra colección de productos, que incluye aceites esenciales puros, bálsamos para dolores musculares y varices, entre otros, está diseñada para proporcionar alivio y confort de manera natural. Nos enorgullece ofrecer productos 100% naturales y libres de crueldad animal, formulados con ingredientes cuidadosamente seleccionados para promover el bienestar físico y emocional.",
    imagenPrincipal: "https://res.cloudinary.com/dkqp3wkbi/image/upload/v1679561440/222_yvkrwm.png"
  }
};

export const TiendaEnLineas = () => {
  const [marcas, setMarcas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/marcas`);
        const data = await response.json();
        setMarcas(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching marcas:", error);
        setLoading(false);
      }
    };
    fetchMarcas();
  }, []);

  if (loading) {
    return <Cargando />
  }

  // Agrupar marcas por category.name y transformar cada marca al formato esperado
  const categoriasMap = {};
  marcas.forEach(marca => {
    const cat = marca.category;
    if (!cat) return;
    if (!categoriasMap[cat.name]) {
      categoriasMap[cat.name] = {
        id: cat._id,
        idScroll: cat._id,
        titulo: cat.name,
        description: cat.description,
        imagenPrincipal: cat.bannerImage?.original || '',
        marcas: []
      };
    }
    categoriasMap[cat.name].marcas.push({
      marcaId: marca._id,
      nombres: marca.name,
      mostrar: false,
      imagenMarcas: [{ img: marca.logo?.thumb || '' }],
      marcaDescription: marca.description,
      imgCertificaciones: (marca.certificates || []).map(cert => cert.icon?.thumb || '')
    });
  });

  const categorias = Object.values(categoriasMap);

  return (
    <>
      {categorias.map((categoria, index) => (
        <SubMarcas key={categoria.id} categoria={categoria} marcas={categoria.marcas} index={index} />
      ))}
    </>
  );
};
